import axios from 'axios';
import apiConfig from '../config/api.config';

const apiClient = axios.create({
  baseURL: apiConfig.baseURL,
  timeout: apiConfig.timeout,
  headers: apiConfig.headers
});

const footballService = {
  /**
   * Tüm liglerin listesini çeker
   */
  async getLeagues() {
    try {
      const requestBody = apiConfig.formatRequestBody({
        url: 'futbol-ligleri',
        selectFields: ['Key'],
        sortBy: 'Key',
        sortAscending: true,
        pageSize: 25
      });
      
      const response = await apiClient.post(apiConfig.endpoint, requestBody);

      if (response.data.isSuccess) {
        return {
          success: true,
          data: response.data.data.map(item => ({
            key: item.properties.Key,
            title: item.title,
            url: item.url
          }))
        };
      }
      return { success: false, errors: response.data.errors };
    } catch (error) {
      console.error('Leagues API Error:', error);
      return { success: false, errors: [error.message] };
    }
  },

  /**
   * Belirli bir ligin puan durumunu çeker
   * @param {string} leagueKey - Lig key'i (örn: "super-lig")
   */
  async getStandings(leagueKey) {
    try {
      const requestBody = apiConfig.formatRequestBody({
        url: 'futbol-fikstur',
        selectFields: [
          'Rank',
          'Draw',
          'Lose',
          'Win',
          'Play',
          'Point',
          'GoalFor',
          'GoalAgainst',
          'GoalDistance',
          'TeamName',
          'League'
        ],
        sortBy: 'Rank',
        sortAscending: true,
        filters: {
          League: {
            Filter: 'Equal',
            Value: leagueKey
          }
        },
        pageSize: 50
      });
      
      const response = await apiClient.post(apiConfig.endpoint, requestBody);

      if (response.data.isSuccess) {
        return {
          success: true,
          data: response.data.data.map(item => ({
            rank: item.properties.Rank,
            teamName: item.properties.TeamName,
            played: item.properties.Play,
            won: item.properties.Win,
            drawn: item.properties.Draw,
            lost: item.properties.Lose,
            goalsFor: item.properties.GoalFor,
            goalsAgainst: item.properties.GoalAgainst,
            goalDifference: item.properties.GoalDistance,
            points: item.properties.Point,
            url: item.url
          }))
        };
      }
      return { success: false, errors: response.data.errors };
    } catch (error) {
      console.error('Standings API Error:', error);
      return { success: false, errors: [error.message] };
    }
  },

  /**
   * Belirli bir ligin gol krallarını çeker
   * @param {string} leagueKey - Lig key'i (örn: "super-lig")
   */
  async getTopScorers(leagueKey) {
    try {
      const requestBody = apiConfig.formatRequestBody({
        url: 'futbol-gol-krallari',
        selectFields: ['PlayerName', 'Goals', 'League'],
        sortBy: 'Goals',
        sortAscending: false,
        filters: {
          League: {
            Filter: 'Equal',
            Value: leagueKey
          }
        },
        pageSize: 20
      });
      
      const response = await apiClient.post(apiConfig.endpoint, requestBody);

      if (response.data.isSuccess) {
        return {
          success: true,
          data: response.data.data.map((item, index) => ({
            rank: index + 1,
            playerName: item.properties.PlayerName,
            goals: item.properties.Goals,
            url: item.url
          }))
        };
      }
      return { success: false, errors: response.data.errors };
    } catch (error) {
      console.error('Top Scorers API Error:', error);
      return { success: false, errors: [error.message] };
    }
  }
};

export default footballService;
